import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 overflow-y-auto overflow-x-hidden"
};
const _hoisted_2 = {
  class: "flex min-h-full items-center justify-center sm:p-8 text-center"
};
const _hoisted_3 = {
  class: "max-h-[80vh] overflow-y-auto overflow-x-hidden"
};
const _hoisted_4 = {
  class: "space-y-4"
};
const _hoisted_5 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "background-color": "rgba(0, 0, 0, 0.05)",
    "height": "5rem",
    "padding-left": "1.5rem",
    "padding-right": "0"
  },
  class: "rounded-lg"
};
const _hoisted_6 = {
  class: "mb-2"
};
const _hoisted_7 = {
  style: {
    "display": "inline-flex",
    "width": "1.5rem",
    "justify-content": "space-between"
  }
};
const _hoisted_8 = {
  key: 0,
  class: "sm:ml-[1.5rem] relative mr-2"
};
const _hoisted_9 = {
  key: 1,
  class: "sm:ml-[1.5rem]"
};
const _hoisted_10 = {
  class: "pr-2 mt-6 mb-3 flex justify-center space-x-3"
};
const _hoisted_11 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TransitionChild = _resolveComponent("TransitionChild");
  const _component_DialogTitle = _resolveComponent("DialogTitle");
  const _component_Multiselect = _resolveComponent("Multiselect");
  const _component_RadioSatisfyQuestionnaire = _resolveComponent("RadioSatisfyQuestionnaire");
  const _component_DialogPanel = _resolveComponent("DialogPanel");
  const _component_Dialog = _resolveComponent("Dialog");
  const _component_TransitionRoot = _resolveComponent("TransitionRoot");
  return _openBlock(), _createBlock(_component_TransitionRoot, {
    appear: "",
    show: _ctx.showQuestionnaire,
    as: "template",
    class: "z-20"
  }, {
    default: _withCtx(() => [_createVNode(_component_Dialog, {
      as: "div",
      class: "relative z-20",
      open: _ctx.showQuestionnaire
    }, {
      default: _withCtx(() => [_createVNode(_component_TransitionChild, {
        as: "template",
        enter: "duration-300 ease-out",
        "enter-from": "opacity-0",
        "enter-to": "opacity-100",
        leave: "duration-200 ease-in",
        "leave-from": "opacity-100",
        "leave-to": "opacity-0"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("div", {
          class: "fixed inset-0 bg-black/25"
        }, null, -1)])),
        _: 1
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_TransitionChild, {
        as: "template",
        enter: "duration-300 ease-out",
        "enter-from": "opacity-0 scale-95",
        "enter-to": "opacity-100 scale-100",
        leave: "duration-200 ease-in",
        "leave-from": "opacity-100 scale-100",
        "leave-to": "opacity-0 scale-95"
      }, {
        default: _withCtx(() => [_createVNode(_component_DialogPanel, {
          style: {
            "background": "#F6F9FB"
          },
          class: "w-full max-w-4xl transform overflow-hidden rounded-lg bg-white dark:bg-white p-3 sm:p-6 text-left align-middle shadow-lg dark:shadow-gray-900 transition-all"
        }, {
          default: _withCtx(() => [_createVNode(_component_DialogTitle, {
            as: "h3",
            class: "text-2xl font-bold leading-6 text-slate-800 dark:text-black mb-3 sm:mb-6"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("Questionnaire.title")), 1)]),
            _: 1
          }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("Questionnaire.p1")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("Questionnaire.p2")), 1), _ctx.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[2] || (_cache[2] = [_createElementVNode("div", {
            class: "loading-spinner"
          }, null, -1)]))) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
            return _openBlock(), _createElementBlock("div", {
              key: i
            }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, [_createElementVNode("span", {
              class: _normalizeClass(["text-red-500 font-bold", item.required ? '' : 'invisible'])
            }, "*", 2), _createTextVNode(_toDisplayString(i + 1) + ". ", 1)]), _createTextVNode(" " + _toDisplayString(item.question), 1)]), item.type === 'multi-select' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[3] || (_cache[3] = _createElementVNode("div", null, null, -1)), _createVNode(_component_Multiselect, {
              modelValue: _ctx.userResults[i],
              "onUpdate:modelValue": $event => _ctx.userResults[i] = $event,
              placeholder: item.others.placeholder,
              label: "label",
              "track-by": "value",
              options: item.options,
              multiple: true,
              "close-on-select": false,
              "select-label": "",
              "deselect-label": "",
              "selected-label": "",
              "max-height": 150,
              "option-height": 30
            }, {
              noResult: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("Questionnaire.multiSelectNoResult")), 1)]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "options"])])) : _createCommentVNode("", true), item.type === 'single-select' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_RadioSatisfyQuestionnaire, {
              hints: [...item.options],
              others: item.others,
              questionIndex: i,
              onUpdateValue: $options.updateFormValue,
              formValues: _ctx.userResults
            }, null, 8, ["hints", "others", "questionIndex", "onUpdateValue", "formValues"])])) : _createCommentVNode("", true)]);
          }), 128))]), _createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
            class: "text-xl btn2 inline-flex justify-center rounded-full px-4 py-1.5 shadow-lg hover:shadow-lg bg-indigo-500 dark:bg-indigo-600 text-black hover:bg-indigo-600 dark:hover:bg-indigo-500 transition-colors duration-200",
            onClick: _cache[0] || (_cache[0] = (...args) => $options.closeDialog && $options.closeDialog(...args)),
            disabled: $options.disableSubmit
          }, _toDisplayString(_ctx.$t("Questionnaire.submit")), 9, _hoisted_11)])])]),
          _: 1
        })]),
        _: 1
      })])])]),
      _: 1
    }, 8, ["open"])]),
    _: 1
  }, 8, ["show"]);
}